export default function AVERAGEIF() {
  return (
    <div className="p-4">
      <h1>AVERAGEIF</h1>
    </div>
  );
}
